import { render } from "./EligibilityHospice.vue?vue&type=template&id=9e779666&ts=true"
import script from "./EligibilityHospice.vue?vue&type=script&lang=ts"
export * from "./EligibilityHospice.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__